export default __webpack_public_path__ + "static/media/close-thin-C4.dec01b4c.svg";